import { styled, Switch } from '@mui/material';

export const SwitchStyled = styled(Switch)<{ size: string }>(
  ({ theme, size }) => ({
    width: size === 'medium' ? 48 : 40,
    height: size === 'medium' ? 24 : 20,

    padding: 0,

    '& .MuiSwitch-switchBase': {
      padding: size === 'medium' ? 3 : 2,

      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: size === 'medium' ? 'translateX(22px)' : 'translateX(20px)',
        color: theme.palette.primary.light,
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.surface4,
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },

      '&:not(.Mui-checked) .MuiSwitch-thumb': {
        color: theme.palette.text3,
      },

      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },

    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.surface4,
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
    '& .MuiSwitch-thumb': {
      width: size === 'medium' ? 18 : 15,
      height: size === 'medium' ? 18 : 15,
    },
  }),
);

export const SwitchContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(2),
}));
